var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 23 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 27,
    width: 25,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    fill: "none",
    id: "XMLID_276_",
    d: "m20.378962,3.034412c-0.218717,-0.637506 -0.681922,-1.034177 -1.208561,-1.034177l-15.840147,0c-0.526639,0 -0.989844,0.396671 -1.209222,1.034177c-0.217396,0.632194 -0.142067,1.354701 0.196251,1.884186c0,0 0.000661,0.000885 0.000661,0.000885l6.289276,9.805203l0,7.640338c0,0.326722 0.134138,0.626881 0.34889,0.780945c0.097795,0.069949 0.204841,0.10448 0.311887,0.10448c0.128191,0 0.255721,-0.050469 0.366731,-0.148752l3.964662,-3.541703c0.183696,-0.164689 0.294046,-0.440942 0.294046,-0.736674l0,-4.098635l6.289937,-9.805203c0.338318,-0.53037 0.413646,-1.252877 0.19559,-1.885071z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    d: "m21.874543,17.859232",
    opacity: 1,
    strokeWidth: 1.5,
    stroke: "",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("text", {
    stroke: "#000000",
    transform: "matrix(0.5897653917561507,0,0,0.6381102926387088,-27.358729255383956,-50.045238899679376) ",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 24,
    id: "svg_3",
    y: 116.653799,
    x: 71.088877,
    strokeWidth: 0,
    fill: "#000000"
  }, "+"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.fedcb5eb23c173245faa60096ad291fe.svg";
export { ForwardRef as ReactComponent };